module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/3/video-preview-3-31b4bd450eb748ffce14caa92b2e5243.png";